var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 0.666504C4.39163 0.666504 0.666626 4.3915 0.666626 8.99984C0.666626 13.6082 4.39163 17.3332 8.99996 17.3332C13.6083 17.3332 17.3333 13.6082 17.3333 8.99984C17.3333 4.3915 13.6083 0.666504 8.99996 0.666504ZM13.1666 11.9915L11.9916 13.1665L8.99996 10.1748L6.00829 13.1665L4.83329 11.9915L7.82496 8.99984L4.83329 6.00817L6.00829 4.83317L8.99996 7.82484L11.9916 4.83317L13.1666 6.00817L10.175 8.99984L13.1666 11.9915Z",
    fill: "#eb672d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconClose);
export default __webpack_public_path__ + "static/media/searchIconClose.6aabbfa328f86a8bb411012fe63f55cc.svg";
export { ForwardRef as ReactComponent };